import VerticalFlex from "layouts/flex/VerticalFlex";
import style from "./WeeklySalesVolume.module.scss";
import FlexChild from "layouts/flex/FlexChild";
import Center from "layouts/wrapper/Center";
import P from "components/P";
import CustomIcon from "components/icons/CustomIcon";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import clsx from "classnames";
import { useEffect, useState } from "react";
import { adminRequester, requester } from "App";
import NiceModal from "@ebay/nice-modal-react";

function WeeklySalesVolume() {
  const [user, setuser] = useState();
  const [data, setData] = useState([]);
  const [mounted, setMounted] = useState(false);
  const start_date = new Date();
  start_date.setDate(start_date.getDate() - start_date.getDay());
  const end_date = new Date();
  useEffect(() => {
    setMounted(true);
    adminRequester.getCurrentUser(({ user }) => setuser(user));
  }, []);

  useEffect(() => {
    if (mounted && user) {
      const data = {
        status: "selling",
        start_date: start_date,
        end_date: end_date,
        interval: "week",
        limit: 5,
      };
      if (user.role === "member") {
        data.store_id = user.store_id;
      }
      adminRequester.getStatistic(data, (result) => {
        const data = result.data;

        if (!data || data?.length === 0) {
          setData([
            { product: "-", option: "-", count: null },
            { product: "-", option: "-", count: null },
            { product: "-", option: "-", count: null },
            { product: "-", option: "-", count: null },
            { product: "-", option: "-", count: null },
          ]);
        } else setData(data);
      });
    }
  }, [mounted, user]);

  return (
    <div className={style.container}>
      <VerticalFlex>
        <FlexChild>
          <div className={style.label}>
            <HorizontalFlex gap={10}>
              <FlexChild width={"max-content"}>
                <CustomIcon name={"statisticsSales"} width={20} />
              </FlexChild>
              <FlexChild>
                <P>주간 판매량 BEST 5</P>
              </FlexChild>
              <FlexChild width={"max-content"}>
                <P
                  hover
                  cursor
                  size={12}
                  onClick={() =>
                    data?.length > 0 &&
                    NiceModal.show("showData", {
                      title: "주간 취소 및 반품 순위 BEST",
                      headers: [
                        { label: "index", Cell: ({ index }) => index + 1 },
                        { label: "상품명", code: "product" },
                        { label: "옵션명", code: "option" },
                        { label: "수량", code: "count" },
                      ],
                      requester: (data, callback) =>
                        adminRequester.getStatistic(
                          {
                            ...data,
                            status: "selling",
                            start_date: start_date,
                            end_date: end_date,
                            interval: "week",
                          },
                          callback
                        ),
                      limit: 20,
                    })
                  }
                >
                  +더보기
                </P>
              </FlexChild>
            </HorizontalFlex>
          </div>
        </FlexChild>
        <FlexChild width={"90%"}>
          <table className={style.table}>
            <thead className={style.thead}>
              <tr>
                <th className={style.th}>순위</th>
                <th className={style.th}>상품명</th>
                <th className={style.th}>옵션명</th>
                <th className={style.th}>수량</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {data &&
                data.map((row, index) => (
                  <tr key={index} className={style.tr}>
                    <td className={style.td}>
                      <div
                        className={clsx(
                          style.tdLabel,
                          index < 3 ? style.specialTdLabel : null
                        )}
                      >
                        {index + 1}
                      </div>
                    </td>
                    <td
                      className={clsx(
                        style.td,
                        index < 3 ? style.specialRank : null
                      )}
                    >
                      {row.product}
                    </td>
                    <td
                      className={clsx(
                        style.td,
                        index < 3 ? style.specialRank : null
                      )}
                    >
                      {row.option}
                    </td>
                    <td
                      className={clsx(
                        style.td,
                        index < 3 ? style.specialRank : null
                      )}
                    >
                      {row.count}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </FlexChild>
      </VerticalFlex>
    </div>
  );
}

export default WeeklySalesVolume;
